<template>
  <div class="new">
    <div class="block" v-if="!opdracht.tekenaar">
      <Koppelen :opdrachtId="opdrachtId" />
    </div>
    <div class="block" v-if="opdracht.intakeTekenaar">
      <IntakeTekenaar :intake="opdracht.intakeTekenaar" />
    </div>
    <div class="block" v-if="opdracht.shadowStatus && opdracht.shadowStatus.gestart">
      <StartFormulierTekenaar :startLog="opdracht.shadowStatus.gestart" />
    </div>
    <div class="block" v-if="facturen.length">
      <Facturen :facturen="facturen" />
    </div>
  </div>
</template>

<script>
import store from "../../../store"
import { db } from "@/firebase"

import Koppelen from "./Koppelen"
import IntakeTekenaar from "./IntakeTekenaar"
import StartFormulierTekenaar from "./StartFormulierTekenaar"
import Facturen from "./Facturen"

export default {
  components: { Koppelen, IntakeTekenaar, StartFormulierTekenaar, Facturen },
  props: ["opdrachtId"],
  data() {
    return {
      facturen: []
    }
  },
  mounted() {
    this.snapshotListener = db
      .collection(`facturen-incoming`)
      .where("opdrachtId", "==", this.opdrachtId)
      .onSnapshot(e => {
        let newArray = []

        e.forEach(g => {
          newArray.push({
            ...g.data(),
            id: g.id
          })
        })

        this.facturen = newArray
      })
  },
  computed: {
    opdracht() {
      return store.getters.allOpdrachten.find(opdracht => opdracht.id == this.opdrachtId)
    }
  }
}
</script>

<style lang="sass" scoped>
.block
  background-color: rgba(0, 0, 0, 0.02)
  padding: 30px 40px
  border-bottom: 1px solid rgba(0, 0, 0, 0.1)
</style>
